export default __webpack_public_path__ + "static/media/icon_zone_control_6.7508ba47.png";